import script from "./Siding09Trim.vue?vue&type=script&setup=true&lang=ts"
export * from "./Siding09Trim.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__